import { useEffect, useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Membership from "@/components/Membership";
import PreBridal from "@/components/PreBridal";
import Academy from "@/components/Academy";
import Gallery from "@/components/Gallery";
import Certifications from "@/components/Certifications";
import Testimonials from "@/components/Testimonials";
import BookingForm from "@/components/BookingForm";
import Contact, { Footer } from "@/components/Contact";
import FloatingButtons from "@/components/FloatingButtons";
import { Sparkles } from "lucide-react";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App relative min-h-screen">
      {/* Premium loading screen */}
      <div className={`loader-wrap ${loading ? "" : "hide"}`}>
        <div className="text-center">
          <div className="relative inline-block">
            <div className="loader-ring" />
            <Sparkles
              size={20}
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#d4af37] animate-shimmer"
            />
          </div>
          <div className="mt-4 font-display text-lg text-[#b56477] italic">
            Anshi's Makeover
          </div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#d4af37] mt-1">
            Loading luxury...
          </div>
        </div>
      </div>

      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Membership />
        <PreBridal />
        <Academy />
        <Gallery />
        <Certifications />
        <Testimonials />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
